const stats = [
  { value: "15+", label: "Years Experience", icon: "ri-time-line" },
  { value: "500+", label: "Projects Completed", icon: "ri-building-line" },
  { value: "200+", label: "Happy Clients", icon: "ri-group-line" },
  { value: "8", label: "Core Services", icon: "ri-tools-line" },
];

const expertise = [
  { label: "Mechanical Technicians", icon: "ri-settings-3-line" },
  { label: "Electrical Engineers", icon: "ri-flashlight-line" },
  { label: "Electronics Specialists", icon: "ri-cpu-line" },
  { label: "PLC / SCADA Experts", icon: "ri-terminal-box-line" },
  { label: "HVAC Technicians", icon: "ri-temp-cold-line" },
  { label: "Fabrication Welders", icon: "ri-fire-line" },
];

export default function AboutFormula() {
  return (
    <>
      {/* Our Formula */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

            {/* Left text */}
            <div>
              <span className="text-cyan-600 text-xs font-semibold uppercase tracking-widest">The secret behind our success</span>
              <h2 className="text-gray-900 text-4xl font-extrabold uppercase tracking-tight mt-3 leading-tight">
                Our <span className="text-cyan-600">Formula</span>
              </h2>
              <div className="w-14 h-1 bg-cyan-500 rounded-full mt-4 mb-6"></div>

              <p className="text-gray-600 text-sm leading-relaxed">
                Our key factor in machine repair relies basically in our manpower. Our most valuable resources are composed of highly skilled mechanical, electrical and electronics technicians who are constantly under training to offer you the latest tools to solve new generation machine breakdowns — and of course thanks to the knowledge gained through valuable hands-on experience on actual industrial machine repair services.
              </p>
              <p className="text-gray-600 text-sm leading-relaxed mt-4">
                At <strong className="text-gray-800">ISMAN COMPANY</strong> we consider the technical requirements for ensuring that the outcome of our machine repair service can be as reliable and durable as possible, proven against any worries in the near future for mechanical or electrical failures.
              </p>

              <div className="mt-8 grid grid-cols-2 gap-3">
                {expertise.map((item) => (
                  <div key={item.label} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100">
                    <span className="w-8 h-8 flex items-center justify-center bg-cyan-100 rounded-lg shrink-0">
                      <i className={`${item.icon} text-cyan-600 text-sm`}></i>
                    </span>
                    <span className="text-xs text-gray-700 font-medium leading-tight">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right — stats + logo */}
            <div className="flex flex-col items-center gap-8">
              <div className="relative">
                <div className="w-56 h-56 rounded-full bg-cyan-50 border-4 border-cyan-100 flex items-center justify-center">
                  <img
                    src="/logo.png"
                    alt="ISMAN Logo"
                    className="h-28 w-auto object-contain"
                  />
                </div>
                {/* Spinning ring */}
                <div className="absolute inset-0 rounded-full border-2 border-dashed border-cyan-300/50 animate-spin" style={{ animationDuration: "20s" }}></div>
              </div>

              <div className="grid grid-cols-2 gap-4 w-full max-w-sm">
                {stats.map((stat) => (
                  <div key={stat.label} className="bg-gray-50 rounded-lg p-5 text-center border border-gray-100">
                    <div className="w-9 h-9 flex items-center justify-center bg-cyan-100 rounded-lg mx-auto mb-2">
                      <i className={`${stat.icon} text-cyan-600`}></i>
                    </div>
                    <p className="text-2xl font-extrabold text-cyan-600">{stat.value}</p>
                    <p className="text-xs uppercase tracking-widest text-gray-500 mt-1 leading-tight">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-16 bg-cyan-700">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h3 className="text-white text-3xl font-extrabold uppercase tracking-tight">
            Ready to Work With Us?
          </h3>
          <p className="text-cyan-100 text-sm mt-3 max-w-xl mx-auto">
            We provide solutions and take away your worries. Contact ISMAN today for a free consultation on your engineering needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <a
              href="tel:0724114555"
              className="bg-white text-cyan-700 font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider hover:bg-cyan-50 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              072 411 4555
            </a>
            <a
              href="mailto:info@isman.co.ke"
              className="border-2 border-white/40 text-white hover:border-white font-semibold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-mail-line"></i>
              info@isman.co.ke
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
